// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'

import {
  Input,
  Button,
  Heading,
  KeyValueTable as InputTable,
  EmployerGroupSelect
} from '../../'

import { normalizePhoneNumber } from '../../../utils'

import {
  MUTATION_EMPLOYER,
  MUTATION_IDENTITY,
  MUTATION_ADDRESS
} from '../../../mutations'


export class EmployerAdd extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    employerId: PropTypes.string.isRequired,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  state = {
    identityExistsAlready: false,
    // identity info
    identityValue: '',
    // employer info
    employerGroup: '',
    friendlyName: '',
    // address info
    cellphoneNumber: null,
    emailAddress: null,
    // validation
    errorFields: []
  }

  validateInput = (field, value) => {
    if (field === 'identityValue') {
      return value && value.includes('/')
    }

    return true
  }

  requiredInputProvided = () => (
    !!this.state.identityValue &&
    !!this.state.friendlyName
  )

  canSave = () => this.requiredInputProvided() && this.state.errorFields.length === 0

  save = (identityMutate, employerMutate, addressMutate) => {
    let input = {
      firstName: this.state.friendlyName,
      identityType: "cipc",
      identityValue: this.state.identityValue
    }

    identityMutate({ variables: { input }})
    .then(this.setState({ errorFields: [] }))
    .then(({ data }) => {
      // at this point the Identity record has been successfully saved
      let input = {
        identity: data.identityMutate.identity.id,
        friendlyName: this.state.friendlyName,
      }

      if (this.state.employerGroup) {
        input.employergroup = this.state.employerGroup
      }

      if (this.state.notes) {
        input.notes = this.state.notes
      }
      employerMutate({ variables: { input } })
      .then(({ data }) => {
        const employerIdentityId = data.employerMutate.employer.identity.id
        // at this point the Employer record has been successfully saved
        if (!!this.state.cellphoneNumber) {
          addressMutate({
            variables: {
              input: {
                identity: employerIdentityId,
                addressType: 'msisdn',
                addressValue: normalizePhoneNumber(this.state.cellphoneNumber),
                default: true
              }
            }
          })
          .catch(error => console.error('there was an error saving the cellphone number', error))
        }
        else if (!!this.state.emailAddress) {
          addressMutate({
            variables: {
              input: {
                identity: employerIdentityId,
                addressType: 'email',
                addressValue: this.state.emailAddress,
                default: true
              }
            }
          })
          .catch(error => console.error('there was an error saving the email address', error))
        }
        this.props.onSuccess()
      })
      .catch(error => console.error('there was an error saving the employer', error))
    })
    .catch(error => console.error('there was an error saving the identity', error))
  }


  handleInputValueChange = (e) => {
    let field = e.target.id
    let newValue = e.target.value

    let newState = {
      [field]: newValue
    }

    let index = this.state.errorFields.indexOf(field)
    if (this.validateInput(field, newValue) && index > -1) {
      // if new value validates and in errorFields state array, remove
      let errorFields = [...this.state.errorFields]
      errorFields.splice(index, 1)
      newState.errorFields = errorFields
    }
    else if (!this.validateInput(field, newValue) && index === -1) {
      // if new value does not validate and not in errorFields state array, add
      newState.errorFields = [...this.state.errorFields, field]
    }

    this.setState(newState)
  }

  getInputForm = () => {
    let requiredInputProvided = this.requiredInputProvided()
    return {
      'Employer group': <EmployerGroupSelect
        id='employerGroup'
        value={this.state.employerGroup}
        onChange={this.handleInputValueChange}
      />,
      '*CIPC number':  <Input
        id='identityValue'
        placeholder='CIPC number'
        value={this.state.identityValue || ''}
        onChange={this.handleInputValueChange}
        onBlur={this.autoFillAfterIdentityNumberInput}
        hasError={requiredInputProvided && this.state.errorFields.includes('identityValue')}
      />,
      '*Name (commonly used)': <Input
        id='friendlyName'
        placeholder='Friendly name'
        value={this.state.friendlyName || ''}
        onChange={this.handleInputValueChange}
        hasError={requiredInputProvided && this.state.errorFields.includes('friendlyName')}
      />,
      'Email address': <Input
        id='emailAddress'
        placeholder='Enter address'
        value={this.state.emailAddress}
        onChange={this.handleInputValueChange}
      />,
      'Cellphone number': <Input
        id='cellphoneNumber'
        placeholder='Enter number'
        value={this.state.cellphoneNumber}
        onChange={this.handleInputValueChange}
      />,
      'Notes': <Input
        id='notes'
        placeholder='Notes (if any)'
        value={this.state.notes}
        onChange={this.handleInputValueChange}
      />
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.props.title &&
          <Heading className='slds-text-align_center'>
            {this.props.title}
          </Heading>
        }
        <InputTable
          data={this.getInputForm()}
          keyColumnSize='1-of-2'
        />
        <div className='slds-m-top_large slds-clearfix'>
          <div className='slds-text-align_center'>
            <Button
              onClick={this.props.onCancel}
              minWidth={120}
              className='u-text-caps'>
              Cancel
            </Button>
            <Mutation mutation={MUTATION_EMPLOYER}>
              {(employerMutate, { data }) => (
                <Mutation mutation={MUTATION_IDENTITY}>
                  {(identityMutate, { data }) => (
                    <Mutation mutation={MUTATION_ADDRESS}>
                      {(addressMutate, { data }) => (
                        <Button
                          type='brand'
                          onClick={() => this.save(identityMutate, employerMutate, addressMutate)}
                          disabled={!this.canSave()}
                          minWidth={120}
                          className='u-text-caps'>
                          Save
                        </Button>
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </Mutation>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-add/index.js